import { render } from "./PrintDataBlock.vue?vue&type=template&id=20893b45&scoped=true"
import script from "./PrintDataBlock.vue?vue&type=script&lang=js"
export * from "./PrintDataBlock.vue?vue&type=script&lang=js"

import "./PrintDataBlock.vue?vue&type=style&index=0&id=20893b45&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20893b45"]])

export default __exports__